"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = ["mat-toolbar[_ngcontent-%COMP%]{padding:0 30px}.action-bar-content[_ngcontent-%COMP%]{display:flex;width:100%;height:100%;flex-direction:row;align-items:center;justify-content:space-between;position:relative;z-index:1;border-bottom:1px solid #ccc}.action-bar-content[_ngcontent-%COMP%]   .custom-subnav[_ngcontent-%COMP%]{position:relative}.action-bar-content[_ngcontent-%COMP%]   .custom-subnav[_ngcontent-%COMP%]   .links[_ngcontent-%COMP%]{margin:0}"];
exports.styles = styles;
